import React from 'react';
import PropTypes from 'prop-types';
import {EmptyHolder} from './EmptyHolder';
import {Feedback} from '../SharedComponents/Feedback';
import {RemoveIcon} from './RemoveIcon';
import {SlideThreeOption} from './SlideThreeOption';
import {SlideOneOption} from './SlideOneOption';
import './style.scss';

const OPTION_ID = 'optionID';

/*
 * NodeHolder : Component acts as placeholder for DesignSection SlideOne Step
 */
function Component(props) {
  const onOptionDrop = (event) => {
    const optionId = parseInt(event.dataTransfer.getData(OPTION_ID));
    if (props.onOptionDrop) {
      props.onOptionDrop({
        optionId,
        groupId: props.groupId,
        nodeId: props.nodeId,
      });
    }
  };

  const removeOption = () => {
    props.removeOption(props.nodeId, props.groupId);
  };

  const getFeedbackMessage = () => {
    let message = '';
    let totalMessages = props.errorFeedbacks.length;
    if (props.wrongAttempts >= totalMessages) {
      message = props.errorFeedbacks[totalMessages - 1];
    } else if (props.wrongAttempts <= 0) {
      message = props.errorFeedbacks[0] || '';
    } else {
      message = props.errorFeedbacks[props.wrongAttempts - 1];
    }
    return message;
  };

  if (props.droppedId === null) {
    return (
      <EmptyHolder
        placeholder={props.placeholder}
        onOptionDrop={onOptionDrop}
      />
    );
  } else {
    const correct = props.nodeId === props.droppedId;
    const message = getFeedbackMessage();
    return React.createElement(
      props.dropComponent,
      {
        ...props.droppedOption,
        feedback: React.createElement(Feedback, {correct, message}),
      },
      correct ? [] : <RemoveIcon removeOption={removeOption} />
    );
  }
}

Component.propTypes = {
  /**
   * List of feedback messages
   */
  errorFeedbacks: PropTypes.arrayOf(PropTypes.string),
  /**
   * React component to be set as droppedComponent.
   */
  dropComponent: PropTypes.func,
  /**
   * Id of component dropped in Node
   */
  droppedId: PropTypes.number,
  /**
   * Object contains details of option currently
   * dropped in the node.
   */
  droppedOption: PropTypes.shape({
    /**
     * Unique Id of the dropped option
     */
    id: PropTypes.number.isRequired,
    /**
     * Text to dispaled on the option
     */
    text: PropTypes.string.isRequired,
    /**
     * Color hex value for the option
     */
    groupColor: PropTypes.string.isRequired,
  }),
  /*
   * placeholder message to show if no option is dropped
   */
  placeholder: PropTypes.string,
  /**
   * Unique Id for the node
   */
  nodeId: PropTypes.number,
  /**
   * Unique for the group node belogs to
   */
  groupId: PropTypes.number,
  /**
   * Function involked when an option is dropped
   * on EmptyNodeHolder
   */
  onOptionDrop: PropTypes.func,
  /**
   * Funtion involked when TrashCan icon on a
   * wrongly dropped Option is clicked
   */
  removeOption: PropTypes.func,
  /**
   * Counter for number for error attempts,
   * Used to select appropriate feedback message
   */
  wrongAttempts: PropTypes.number.isRequired,
};

Component.defaultProps = {
  errorFeedbacks: [''],
  droppedId: null,
  wrongAttempts: 0,
};

export const NodeHolder = {
  Component,
  SlideThreeOption,
  SlideOneOption,
};
